@import "styles/variables";

.label {
  position: relative;
  font-family: var(--font-stack-bold);
  font-size: var(--font-size-medium);
  letter-spacing: .5px;
}

.inputFieldContainer {
  position: relative;
}

.date, .time {
  display: inline-block;
  position: relative;
}

.number {
  display: inline-block;
  position: relative;
}

.number + .number {
  margin-left: 15px;
}

.inputField {
  border-radius: var(--input-border-radius);
  background-color: var(--color-white);
  border: 1px solid;
  border-color: var(--color-grey);
  box-sizing: border-box;
  width: 100%;
  padding: 7px;
  font-family: var(--font-stack-default);
  font-size: var(--font-size-medium);
  font-weight: normal;
  color: var(--color-black-transparent);
  outline: none;
  margin: 6px 0 0;
  height: 36px;
}
.inputFieldContainer > div > span {
  margin-top: 10px;
}
.inputFieldContainer > div > span > button {
  background-color: white;
}
.inputFieldContainer > div > span > button > span {
  font-size: 16px;
  color: var(--color-black-transparent);
  content: none;
}

input[type="search"].inputField {
  box-sizing: border-box;
  background-image: url('/static/img/search-yellow.png');
  background-size: 14px;  
  background-repeat: no-repeat;
  background-position: center right 12px;
}
input[type="search"]:focus {
  background: none;
}
input[type="search"].inputField:not(:placeholder-shown) {
  background: none;
}

input[type="number"] {
  width: 36px;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}

input[type="time"] {
  border-radius: 2px;
/*  background-image: url('/static/img/time.png');
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 85% center;*/
  padding-right: 20px;
  width: 100px;
}
input::-webkit-clear-button {
  -webkit-appearance: none;
}
/*input[type="time"]:hover,
input[type="time"]:focus  {
  background: none;
}*/

input[type="date"] {
  border-radius: 2px;
/*  background-image: url('/static/img/date.png');
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 94% center;*/
}
input[type="date"]:hover,
input[type="date"]:focus  {
  background: none;
}

input {
  transition: box-shadow 0.1s ease-out, transform 0.1s ease-out;
}

input:focus {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

input.has-error {
  border-color: var(--color-border-error);
}

.no-error {
  display: none;
}

/*.has-error {
  display: block;
}*/

/*.error {
  border-radius: 4px;
  font-family: var(--font-stack-default);
  font-weight: normal;
  font-size: 14px;
  box-sizing: border-box;
  position: absolute;
  background: #F67676;
  width: 150px;
  height: 43px;
  right: -165px;
  bottom: -3px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}*/

.error {
  position: absolute;
  border-radius: 2px;
  font-family: var(--font-stack-bold);
  font-size: 11px;
  color: white;
  box-sizing: border-box;
  background: #fe4545;
  padding: 7px 10px 9px;
  white-space: nowrap;
  top: calc(50% + 3px);
  right: 5px;
  transform: translate(calc(100% + 20px), -50%);
  z-index: 99;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
}

.error > div {
  position: absolute;
  left: -7px;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border-style: solid;
  border-width: 6px 8px 6px 0;
  border-color: transparent #fe4545 transparent transparent;
}

.margin-right {
  margin-right: 15px;
}

.grow {
  position: relative;
  flex-grow: 1;
}

.small {
  position: absolute;
  margin-left: 15px;
  top: 5px;
  max-width: 40px;
}
.small input {
  height: 27px;
}

.flightNumber {
  text-transform: uppercase;
  background-image: url('/static/img/airplane.png');
  background-size: 14px;  
  background-repeat: no-repeat;
  background-position: center right 12px;
}
